import React from 'react';

/**
 * Page d'arrivée d'un compte auquel aucun module n'est attribué.
 *
 * Distincte du « Accès refusé » de `ProtectedRoute`, et la nuance compte pour l'utilisateur :
 * un refus signifie « cette page ne vous est pas destinée », ce qui laisse entendre qu'une
 * autre le serait. Ici, aucune ne l'est — le compte existe mais n'a reçu aucun droit. Afficher
 * un refus enverrait l'utilisateur chercher une page accessible qui n'existe pas.
 */
const AucunModule: React.FC = () => (
    <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        minHeight: '60vh', gap: '12px', color: '#374151', textAlign: 'center', padding: '24px',
    }}>
        <i className="bi bi-person-badge" style={{fontSize: '40px', color: '#6b7280'}} aria-hidden="true"/>
        <h2 style={{margin: 0, fontSize: '18px'}}>Aucun module ne vous est attribué</h2>
        <p style={{margin: 0, color: '#6b7280', maxWidth: '420px'}}>
            Votre compte est bien actif, mais aucun droit d'accès ne lui a encore été donné.
            Demandez à un administrateur de vous attribuer les modules correspondant à votre
            fonction.
        </p>
    </div>
);

export default AucunModule;
